import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from "vue";
import { MatrixSchema, OpenableProps } from "@/types";
import { traceGenerationApiStore } from "@/hooks";
import { Typography, TextButton } from "@/components/common";
import { TraceMatrixCreator } from "@/components/traceLink/save";


/**
 * Displays inputs for generating trace links.
 */
const __default__ = {
  name: "TraceLinkGenerator",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const createEmptyArtifactLevel = (): MatrixSchema[] => [
  { source: "", target: "" },
];

const isValid = ref(false);
const matrices = ref(createEmptyArtifactLevel());

const areMatricesValid = computed(() =>
  matrices.value
    .map((matrix: MatrixSchema) => !!matrix.source && !!matrix.target)
    .reduce((acc: boolean, cur: boolean) => acc && cur, true)
);

/**
 * Resets this component's data.
 */
function handleReset(): void {
  isValid.value = false;
  matrices.value = createEmptyArtifactLevel();
}

/**
 * Attempts to generate the selected trace links.
 */
function handleSubmit(): void {
  traceGenerationApiStore.handleGenerate(matrices.value, {
    onComplete: () => {
      emit("submit");
      handleReset();
    },
  });
}

watch(
  () => props.open,
  (open) => {
    if (!open) return;

    handleReset();
  }
);

watch(
  () => matrices.value,
  () => {
    isValid.value = areMatricesValid.value;
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Typography), {
      el: "p",
      b: "4",
      value: "Select which sets of artifact types that you would like to generate links between."
    }),
    _createVNode(_unref(TraceMatrixCreator), {
      modelValue: matrices.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((matrices).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(TextButton), {
      block: "",
      label: "Generate Trace Links",
      disabled: !isValid.value,
      loading: _unref(traceGenerationApiStore).loading,
      color: "primary",
      "data-cy": "button-trace-generate",
      class: "q-mt-md",
      onClick: handleSubmit
    }, null, 8, ["disabled", "loading"])
  ]))
}
}

})